import * as React from "react";
import NavBar from "../../components/NavBar";
import {Divider} from "@mui/material";
import {Add, Height} from '@mui/icons-material';
import {convertPrice} from "../../assets/js/main";
import {useTranslation} from "react-i18next";
import {setLoading} from "../../redux/loading/actions";
import {useDispatch, useSelector} from "react-redux";
import {useSnackbar} from "notistack";
import HandleFetchData from "../../plugin/HandleFetchData";

export default function Index() {
  const {t} = useTranslation()
  const {enqueueSnackbar} = useSnackbar();
  const {fetchData} = HandleFetchData()

  const dispatch = useDispatch();
  const selector = useSelector((st) => st)
  const tokenStorage = localStorage.getItem('token')
  const [validations, setValidations] = React.useState(null);
  const [contents, setContents] = React.useState('');
  const [price, setPrice] = React.useState('');
  const [weight, setWeight] = React.useState('');
  const [size, setSize] = React.useState('');
  const [width, setWidth] = React.useState('');
  const [height, setHeight] = React.useState('');
  const [length, setLength] = React.useState('');
  const [boxNo, setBoxNo] = React.useState('');
  const [factor, setFactor] = React.useState('');
  const [listBoxSize, setListBoxSize] = React.useState([]);
  const [listBoxNo, setListBoxNo] = React.useState([]);


  React.useEffect(() => {
    getBoxSize()
  }, [])


  // متد دریافت لیست سایز جعبه ها
  const getBoxSize = async () => {
    dispatch(setLoading(true))
    let fetch = await fetchData('', 'GET', '/StandardBoxSize', '', "text/html",'', '','')
    if (fetch?.message === "Network Error" && !tokenStorage) {
      // enqueueSnackbar(t("error.t1"), {
      //   variant: 'error',
      //   TransitionProps: {
      //     direction: 'down',
      //   },
      //   anchorOrigin: {
      //     horizontal: 'center',
      //     vertical: 'top'
      //   }
      // })
    }
    setListBoxSize(fetch?.Data)
    dispatch(setLoading(false))
  }


  return (
     <>
       <NavBar blue back/>

       <div className="container">
         <div className="packingPage desktopSection">
           <div className="row">
             <div className="col-12 col-lg-4">
               <div className="info-box">
                 <h5>{t("packing.t1")}</h5>

                 <p>{t("packing.t2")}: کتاب</p>
                 <p>{t("packing.t3")}: 125،000 {t("packing.t4")}</p>
                 <p>{t("packing.t5")}: 45 {t("packing.t6")}</p>
                 <p>{t("packing.t7")}: سایز 9</p>
                 <p>{t("packing.t8")}: 3</p>
               </div>

               <div className="info-box">
                 <h5>{t("packing.t9")}</h5>
                 <p>{t("packing.t10")}: امین سیرایی</p>
                 <p>{t("packing.t11")}: 09193696975</p>
                 <p>{t("packing.t12")}: تهران - شهرک هما - کوچه پنجم</p>
                 <p>{t("packing.t13")}: اسپید</p>
                 <p>{t("packing.t14")}: دارد</p>
                 <p>{t("packing.t15")}: دارد (16،122 {t("packing.t4")})</p>
                 <p>{t("packing.t16")}: دارد (16،122)</p>
               </div>

             </div>
             <div className="col-12 col-lg-8">
               <h5>{t("packing.t17")}</h5>

               <div className="addItem">
                 <div className="row">
                   <div className="col-12 col-md-6 col-lg-4">
                     <label className="required">{t("packing.t18")}</label>
                     <input type="text" name="contents" value={contents} onChange={(e) => setContents(e.target.value)}/>

                     {
                       validations?.contents_validation &&
                       <p className="error">{validations?.contents_validation}</p>
                     }
                   </div>
                   <div className="col-12 col-md-6 col-lg-4">
                     <label className="required">{t("packing.t19")}</label>
                     <input type="text" name="price" value={price} onChange={(e) => setPrice(e.target.value)}/>

                     {
                       validations?.price_validation &&
                       <p className="error">{validations?.price_validation}</p>
                     }
                   </div>
                   <div className="col-12 col-md-6 col-lg-4">
                     <label className="required">{t("packing.t20")}</label>
                     <input type="text" name="weight" value={weight} onChange={(e) => setWeight(e.target.value)}/>

                     {
                       validations?.weight_validation &&
                       <p className="error">{validations?.weight_validation}</p>
                     }
                   </div>
                   <div className="col-12 col-md-6 col-lg-4">
                     <label className="required">{t("packing.t21")}</label>
                     <select aria-label="Default select example" value={size}
                             onChange={(e) => {
                               setSize(
                                  e?.target?.value === 'max' ?
                                     e?.target?.value
                                     :
                                     listBoxSize?.find(x => x?.Id.toString() === e?.target?.value.toString())?.Name
                               )
                               setLength(
                                  listBoxSize?.find(x => x?.Id.toString() === e?.target?.value.toString())?.Length
                               )
                               setWidth(
                                  listBoxSize?.find(x => x?.Id.toString() === e?.target?.value.toString())?.Width
                               )
                               setHeight(
                                  listBoxSize?.find(x => x?.Id.toString() === e?.target?.value.toString())?.Height
                               )
                             }}>
                       <option value="" selected disabled>{t("homeDesktop.s1.t4.tt10")}</option>
                       {
                         listBoxSize?.map((item, index) => <option key={item?.Id} value={item?.Id}>{item?.Name}</option>)
                       }

                       <option value="max">{t("homeDesktop.s1.t4.tt22")}</option>

                     </select>

                     {
                       size === 'max' &&
                       <div className="row">
                         <div className="col-4">
                           <input type="number" min="1" name="length"
                                  onChange={(e) => setLength(e?.target?.value)}
                                  placeholder={t("multiOrder.s2.t7")} value={length || ""}/>
                         </div>
                         <div className="col-4">
                           <input type="number" min="1" name="width"
                                  onChange={(e) => setWidth(e?.target?.value)}
                                  placeholder={t("multiOrder.s2.t8")} value={width || ""}/>
                         </div>
                         <div className="col-4">
                           <input type="number" min="1" name="height"
                                  onChange={(e) => setHeight(e?.target?.value)}
                                  placeholder={t("multiOrder.s2.t9")} value={height || ""}/>
                         </div>
                       </div>
                     }

                     <p>{t("packing.t25")}: {convertPrice(47000)} {t("packing.t4")}</p>

                     <div className="viewSize">
                       <div className="sizeBox">
                         <div className="length">
                           <div>
                             <Height/>
                             <span>{length}Cm</span>
                           </div>
                           <p>{t("packing.t29")}</p>
                         </div>
                         <div className="width">
                           <div>
                             <Height/>
                             <span>{width}Cm</span>
                           </div>
                           <p>{t("packing.t30")}</p>
                         </div>

                         <div className="height">
                           <div>
                             <Height/>
                             <span>{height}Cm</span>
                           </div>
                           <p>{t("packing.t31")}</p>
                         </div>
                       </div>
                     </div>


                     {
                       validations?.size_validation &&
                       <p className="error">{validations?.size_validation}</p>
                     }
                   </div>
                   <div className="col-12 col-md-6 col-lg-4">
                     <label className="required">{t("packing.t22")}</label>
                     <select aria-label="Default select example" value={boxNo}
                             onChange={(e) => setBoxNo(e?.target?.value)}>
                       <option value="" selected disabled>{t("homeDesktop.s1.t4.tt10")}</option>
                       {
                         listBoxNo?.map((item, index) => <option key={item?.Id} value={item.Id}>{item.Name}</option>)
                       }

                     </select>

                     {
                       validations?.boxNo_validation &&
                       <p className="error">{validations?.boxNo_validation}</p>
                     }
                   </div>
                   <div className="col-12 col-md-6 col-lg-4">
                     <label className="required">{t("packing.t23")}</label>
                     <select aria-label="Default select example" value={factor}
                             onChange={(e) => setFactor(e?.target?.value)}>
                       <option value="" selected disabled>{t("homeDesktop.s1.t4.tt10")}</option>
                       <option value="0">{t("packing.t28")}</option>
                       <option value="1">{t("packing.t27")}</option>
                     </select>

                     {
                       validations?.factor_validation &&
                       <p className="error">{validations?.factor_validation}</p>
                     }


                     <div className="btnGroup_blue">
                       <button className="btnFill">
                         {t("packing.t24")}
                         <Add/>
                       </button>
                     </div>
                   </div>

                 </div>

               </div>
             </div>
           </div>


           <Divider/>


           <div className="_btnGroup_yellow">
             <button className="btnFill">{t("packing.t26")}</button>
           </div>
         </div>
       </div>

     </>
  )
}
